/** Cocina con foco en esta pestaña — no avisar mostrador por cambios que ves acá. */
let kitchenScreenFocused = false;

/** Comandas que pasaron a listo desde Cocina (evita banner en POS al cambiar de pantalla). */
const selfReadyUntil = new Map<string, number>();

const SELF_READY_TTL_MS = 3 * 60 * 1000;

export function setKitchenScreenFocused(focused: boolean): void {
  kitchenScreenFocused = focused;
}

export function isKitchenScreenFocused(): boolean {
  return kitchenScreenFocused;
}

/** Llamar al marcar listo en Cocina (botón o última línea Hecho). */
export function markSelfKitchenReady(ticketId: string): void {
  if (!ticketId) return;
  selfReadyUntil.set(ticketId, Date.now() + SELF_READY_TTL_MS);
}

function pruneSelfReady(nowMs: number): void {
  for (const [id, until] of selfReadyUntil) {
    if (until <= nowMs) selfReadyUntil.delete(id);
  }
}

/** True → no toast ni banda de mostrador para este ticket. */
export function shouldSuppressCounterReadyAlert(ticketId: string): boolean {
  if (isKitchenScreenFocused()) return true;
  const nowMs = Date.now();
  pruneSelfReady(nowMs);
  const until = selfReadyUntil.get(ticketId);
  if (until != null && until > nowMs) return true;
  return false;
}
